import { Typography } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { MULTIPLE_ROUTES_EXIST_IN_AREA } from "../../../consts/strings";

import { View } from "../../View";
import { PickupEditOptionsModalOption } from "./PickupEditOptionsModalOption";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
  },
});

export const PickupEditOptionsModalContent = ({
  options,
  selectedOption,
  onOptionChange,
}) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <Typography>{MULTIPLE_ROUTES_EXIST_IN_AREA}</Typography>
      {options.map((option, index) => (
        <PickupEditOptionsModalOption
          key={index}
          option={option}
          checked={selectedOption === option}
          onOptionChange={onOptionChange}
        />
      ))}
    </View>
  );
};
